// <s-product-rail>: horizontal scroll-snap product row with prev/next buttons.
// Markup: [data-rail-track] scroll container, [data-rail-prev] / [data-rail-next] buttons.
class SProductRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-rail-track]');
    this.prev = this.querySelector('[data-rail-prev]');
    this.next = this.querySelector('[data-rail-next]');
    if (!this.track) return;
    this.onPrev = () => this.go(-1);
    this.onNext = () => this.go(1);
    this.onScroll = () => this.update();
    this.prev?.addEventListener('click', this.onPrev);
    this.next?.addEventListener('click', this.onNext);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.track);
    this.update();
  }

  disconnectedCallback() {
    this.prev?.removeEventListener('click', this.onPrev);
    this.next?.removeEventListener('click', this.onNext);
    this.track?.removeEventListener('scroll', this.onScroll);
    this.resizeObserver?.disconnect();
  }

  go(direction) {
    const rtl = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const items = this.track.children;
    if (!items.length) return;
    // Step by whole cards (width + gap) so the first visible card always lands flush with the edge.
    const first = items[0];
    const second = items[1];
    const step = second ? Math.abs(second.offsetLeft - first.offsetLeft) : first.offsetWidth;
    const visible = Math.max(1, Math.floor((this.track.clientWidth + 2) / step));
    const current = Math.round(Math.abs(this.track.scrollLeft) / step);
    const target = Math.max(0, current + direction * visible) * step;
    this.track.scrollTo({ left: target * rtl, behavior: reduce ? 'auto' : 'smooth' });
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const position = Math.abs(scrollLeft);
    if (this.prev) this.prev.disabled = position <= 2;
    if (this.next) this.next.disabled = position + clientWidth >= scrollWidth - 2;
  }
}

if (!customElements.get('s-product-rail')) customElements.define('s-product-rail', SProductRail);
